<template>
  <div class="selectControlContainer">
      <div class="selectMainTextContainer" @click="openDropDown">
        <div class="selectMainText">{{(value==null?label:selectedItem[textField])}}</div>
          <fa-icon
              :icon="['fas', 'chevron-down']"
              :style="isActive?'tranform:rotate(180deg)':''"
            ></fa-icon>
      </div>
      <div :class="isActive?'dropdownContainer active':'dropdownContainer'">
          <div :class="(value && option[id]==selectedItem[id])?'active singleItem':'singleItem'" @click="selectClicked(option,$event)" v-for="(option,index) in options" :key="index">
            <div class="text">{{option[textField]}}</div>
            <div class="tick">
              <fa-icon
                :icon="['fas', 'check']"
              ></fa-icon>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import "../../scss/select-control.css";

export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    id:{
        type:String,
        required:true
    },
    textField:{
        type:String,
        required:true
    },
    autoSelect:{
        type:Boolean,
        required:false
    },
    label:{
        type:String,
        required:false
    },
    value:{
      type:String
    }
  },
  methods:{
      selectClicked(option,event){
        this.selectedItem=option
        this.$emit('input',option[this.id])
        this.$emit('change',option[this.id])
        this.isActive=false
        event.preventDefault()
        event.stopPropagation()
      },
      openDropDown(event){
        this.isActive=!this.isActive
        event.preventDefault()
        event.stopPropagation()
        window.addEventListener("click",this.closeDropDown)
      },
      closeDropDown(){
        this.isActive=false
        window.removeEventListener("click",this.closeDropDown)
      },
  },
  data(){
      return {
        isActive:false,
        selectedItem:null
      }
  },
  created(){
    this.selectedItem=this.options.find(x=>x[this.id]==this.value)
  }
}
</script>